import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { Box, Button, Tab, Tabs } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import SearchBar from "../../components/SearchBar";
import VenueOwnersList from "../../features/manageVenueOwners/VenueOwnersList";
import DownloadIcon from "@mui/icons-material/Download";
import AddIcon from "@mui/icons-material/Add";
import {
  useDeleteVenueMutation,
  useLazyGetVenueDetailsQuery,
  useLazyGetVenueStorageQuery,
  useLazyVenueExportQuery,
} from "../../services/venue";
import { showError, showToast } from "../../constants/toasts";
import { VenueType } from "../../types/General";
import Loader from "../../constants/Loader";
import { isValidInput } from "../../utils/validations";
import useAuth from "../../hooks/useAuth";

const TAB_TYPES = {
  PENDING: 0,
  APPROVED: 1,
  REJECTED: 2,
};

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageVenueStorageOwners = () => {
  const [getVenueOwner] = useLazyGetVenueStorageQuery();
  const navigate = useNavigate();
  const user = useAuth();
  const skipLoadingRef = useRef(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [venueData, setVenueData] = useState<VenueType[]>([]);
  const [count, setCount] = useState(10);
  const [valueTabs, setValueTabs] = React.useState(0);
  const [topTab, setTopTab] = useState(0);
  const isVenue = topTab === 0;
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setPage(1)
    setValueTabs(newValue);
  };
  const handleChangeTopTabs = (
    event: React.SyntheticEvent,
    newValue: number
  ) => {
    setTopTab(newValue);
  };
  const [exportApi] = useLazyVenueExportQuery();

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage);
  };

  const exportCsv = async () => {
    const type = isVenue ? "VENUE" : "STORAGE";
    try {
      const response = await exportApi({ type }).unwrap();

      if (response?.statusCode === 200) {
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const getVenueOwnerApi = async () => {
    if (!skipLoadingRef.current) setLoading(true);
    try {
      const response = await getVenueOwner({
        page: page,
        search: debouncedSearchTerm,
        limit: 10,
        type: topTab === 0 ? "VENUE" : "STORAGE",
        status:
          valueTabs === TAB_TYPES.PENDING
            ? "PENDING"
            : valueTabs === TAB_TYPES.APPROVED
              ? "APPROVED"
              : valueTabs === TAB_TYPES.REJECTED
                ? "REJECTED"
                : "",
        country: user?.accessRoleId?.country || "",
      } as any).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        setVenueData(response?.data?.data);
        setCount(response?.data?.total);
      }
    } catch (error: any) {
      or(error?.data?.message || "");
    } finally {
      skipLoadingRef.current = false;
    }
  };

  useEffect(() => {
    getVenueOwnerApi();
  }, [valueTabs, page, debouncedSearchTerm, topTab, user]);

  return (
    <>
      <MainContainer>
        <Loader isLoad={loading} />
        <div className="table_header">
          <div className="left_s">
            <Box className="custom_tabs1" sx={{ width: "100%" }}>
              <Tabs
                value={topTab}
                onChange={handleChangeTopTabs}
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label="Venue" {...a11yProps(0)} />
                <Tab label="Storage" {...a11yProps(1)} />
              </Tabs>
            </Box>
          </div>
        </div>

        <div className="main_title">
          <h1>{`Manage ${topTab === 0 ? "Venue" : "Storage"}`}</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
            {`Manage ${topTab === 0 ? "Venue" : "Storage"}`}
          </p>
        </div>

        <div className="table_header">
          <div className="left_s">
            <Box className="custom_tabs1" sx={{ width: "100%" }}>
              <Tabs
                value={valueTabs}
                onChange={handleChangeTabs}
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label="Pending" {...a11yProps(0)} />
                <Tab label="Accepted" {...a11yProps(1)} />
                <Tab label="Rejected" {...a11yProps(2)} />
              </Tabs>
            </Box>
          </div>
        </div>
        <div className="cards">
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  placeholder="Search"
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm("")}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </Box>
            </div>
            <div className="right_s">
              <Button
                className="btn btn_primary"
                onClick={() =>
                  navigate(
                    `/manage-venue-owners/add?type=${isVenue ? "Venue" : "Storage"
                    }`
                  )
                }
              >
                <AddIcon /> Add
              </Button>
              <Button className="btn btn_primary" onClick={exportCsv}>
                <DownloadIcon /> Export
              </Button>
            </div>
          </div>
          <CustomTabPanel value={valueTabs} index={0}>
            <VenueOwnersList
              type="pending"
              venueData={venueData}
              getVenueOwnerApi={getVenueOwnerApi}
              page={page}
              setPage={setPage}
              handlePageChange={handlePageChange}
              count={count}
              venueStorageType={topTab === 0 ? "Venue" : "Storage"}
            />
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={1}>
            <VenueOwnersList
              type="accepted"
              venueData={venueData}
              getVenueOwnerApi={getVenueOwnerApi}
              page={page}
              setPage={setPage}
              handlePageChange={handlePageChange}
              count={count}
              venueStorageType={topTab === 0 ? "Venue" : "Storage"}
            />
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={2}>
            <VenueOwnersList
              type="rejected"
              venueData={venueData}
              getVenueOwnerApi={getVenueOwnerApi}
              page={page}
              setPage={setPage}
              handlePageChange={handlePageChange}
              count={count}
              venueStorageType={topTab === 0 ? "Venue" : "Storage"}
            />
          </CustomTabPanel>
        </div>
      </MainContainer>
    </>
  );
};

export default ManageVenueStorageOwners;
function or(arg0: any) {
  throw new Error("Function not implemented.");
}

